import { render, staticRenderFns } from "./head-report.vue?vue&type=template&id=1723cb04&"
import script from "./head-report.vue?vue&type=script&lang=js&"
export * from "./head-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports